"use client";

import { useEffect } from "react";
import { useServiceContext } from "../../..";

const FreshdeskTag = [
	"category",
	"product",
	"sheet_material",
	"tosize_furniture",
	"general",
	"customer_service",
	"business",
	"cart",
	"checkout",
	"my_account",
	"contact",
] as const;

export type FreshdeskTag = (typeof FreshdeskTag)[number];

export function FreshdeskPageTags({ tags }: { tags: FreshdeskTag[] }) {
	const { setTags } = useServiceContext();

	useEffect(() => {
		if (window.fcWidget?.isLoaded()) {
			window.fcWidget.setTags(tags);
		}

		setTags(tags);

		return () => {
			if (window.fcWidget?.isLoaded()) {
				window.fcWidget.setTags([]);
			}

			setTags([]);
		};
	}, [tags, setTags]);

	return null;
}
